// @flow

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export const getComponentSettings = (state: GlobalState): State => {
  const { componentSettings } = state;
  if (!componentSettings) {
    throw new Error('Missing componentSettings store.');
  }
  return componentSettings;
};

export default null;
